import { useEffect, useState } from 'react';
import { settingsService } from '../services/api';
import type { SiteSettings } from '../types/api';

export function useSettings() {
  const [settings, setSettings] = useState<SiteSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    (async () => {
      const res = await settingsService.getPublic();
      if (!active) return;
      if (res.success && res.data) {
        // Normaliza: algumas APIs retornam array [row]
        const raw: any = res.data as any;
        const first = Array.isArray(raw) ? raw[0] : raw;
        // normalização segura de business_hours caso venha como JSON serializado
        if (first && typeof first.business_hours === 'string' && first.business_hours.startsWith('[')) {
          try {
            first.business_hours = JSON.parse(first.business_hours).join('\n');
          } catch {
            // mantém a string livre caso não seja um array
          }
        }
        setSettings(first as SiteSettings);
        setError(null);
      } else {
        setError(res.error || 'Não foi possível carregar as configurações.');
      }
      setLoading(false);
    })();
    return () => { active = false; };
  }, []);

  return { settings, loading, error };
}


